import React, {FC, useState, Fragment} from "react"

import {PaymentCurrencyType, PaymentMethodKind, Platform} from "@irati/types"
import Loading from "@irati/ui/src/Loading"
import {usePaymentConfigsQuery} from "@irati/payments/hooks"
import Flex from "@irati/ui/src/Flex"

import Cards from "./Cards"
import PayPal from "./PayPal"

interface Props {
  amount: number
  currency: PaymentCurrencyType
  paymentOrderId: string
  returnUrl: string
  onComplete: () => void
  hiddenPaymentMethods?: PaymentMethodKind[]
}

const PaymentFormV2: FC<Props> = ({amount, currency, paymentOrderId, returnUrl, onComplete, hiddenPaymentMethods}) => {
  const [load, setLoad] = useState<Promise<any>>()
  const {data: paymentConfigs, load: paymentConfigsLoad} = usePaymentConfigsQuery({platform: Platform.Web})
  const checkoutComPubKey = paymentConfigs?.provider.pubKey

  if (amount <= 0) {
    return null
  }

  const filteredPaymentMethods =
    paymentConfigs?.paymentMethods?.filter((paymentMethod) => !hiddenPaymentMethods?.includes(paymentMethod.kind)) || []

  const components = filteredPaymentMethods.map((paymentMethodConfigs, i) => {
    switch (paymentMethodConfigs.kind) {
      case PaymentMethodKind.Card:
        return (
          <Fragment key={i}>
            <Cards
              onComplete={onComplete}
              amount={amount}
              currency={currency}
              paymentOrderId={paymentOrderId}
              returnUrl={returnUrl}
              load={load}
              setLoad={setLoad}
              publicKey={checkoutComPubKey!}
              savedCards={paymentMethodConfigs.savedCards || []}
              circuits={paymentMethodConfigs.circuits}
            />
          </Fragment>
        )
      case PaymentMethodKind.PayPal:
        return (
          <Fragment key={i}>
            <PayPal
              paymentMethodConfigs={paymentMethodConfigs}
              amount={amount}
              paymentOrderId={paymentOrderId}
              currency={currency}
              load={load}
              setLoad={setLoad}
              returnUrl={returnUrl}
            />
          </Fragment>
        )
      default:
        return null
    }
  })

  return (
    <Loading load={paymentConfigsLoad} initLoad>
      <Flex direction="column" gap={2}>
        {components}
      </Flex>
    </Loading>
  )
}

export default PaymentFormV2
